import React, { PureComponent } from "react";
import dataProvider, { GET_LIST } from "providers/dataProvider";
import style from "./StatusBar.module.scss";
import { tableColConfig } from "config/resources/requisitionsResource/index.js";
import { withAuthCenter } from "AuthCenter";
import { compose } from "redux";
import helpers from "utils/helpers";
import { userRoles } from "config/userRoles";

class StatusBarContainer extends PureComponent {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      statuses: {},
    };
  }

  componentDidMount() {
    this._isMounted = true;
    setTimeout(() => {
      this.loadData();
    }, 100);
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.onRef(undefined);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.authCenter.token !== this.props.authCenter.token) {
      this.loadData();
    }
  }

  loadData = () => {
    dataProvider(GET_LIST, "requisitions/status_count").then(
      ({ data, total }) => {
        if (this._isMounted) {
          let statuses = {};
          if (data && Array.isArray(data)) {
            data.forEach((d) => {
              statuses[d.reqStatusDesc] = d.reqStatusCount;
            });
          }
          this.setState({ statuses });
        }
      }
    ).catch((error) => {
      console.error("Error loading status data:", error);
    });
  };

  render() {
    let { statuses } = this.state;
    const { currentFilterStatus } = this.props;

    const isMdcls = helpers.can([userRoles.mdcls]);
    const groups = isMdcls ? ["Approval", "Issues"] : tableColConfig.groupsById;

    return (
      <div
        className={style.root}
        style={isMdcls ? { justifyContent: "flex-start", gap: "20px" } : {}}
      >
        {groups.map((status, key) => {
          const isCurrentTab = currentFilterStatus === status;
          return (
            <div
              key={key}
              className={[
                style.item,
                isCurrentTab && style.active,
                status === "Clarification" && style.clarification,
              ].join(" ")}
              style={isMdcls ? { minHeight: "48px", justifyContent: "center", paddingTop: "14px", paddingBottom: "14px" } : {}}
              onClick={() =>
                !isCurrentTab && this.props.handleChangeStatus(status)
              }
            >
              <span className={style.statusName} style={isMdcls ? { marginTop: "auto", marginBottom: "auto" } : {}}>{status}</span>
              {!isMdcls && <span className={style.statusCount}>{statuses[status] || 0}</span>}
            </div>
          );
        })}
      </div>
    );
  }
}

export default compose(withAuthCenter())(StatusBarContainer);
